import { EDA } from "motw_core/Dreams/EDreamAttribute";
import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { IAttributeMapRecord } from "source/app/presentation/MainPanel/Dreams/DreamAttributeIcon/IAttributeMapRecord/IAttributeMapRecord";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

export const GetAttributeIcon = (
    attribute: string,
    attributeMap: IAttributeMapRecord[],
    dream?: IDream
) => {
    if (!attribute) return null;

    const attributeMapRecord = attributeMap.find(
        (elem) => EDA[elem.attribute] === attribute
    );

    if (!attributeMapRecord) {
        return (
            <span style={{ color: `red` }}>
                MISSING ICON MAPPING FOR {attribute}
            </span>
        );
    }

    const isBeingSolved = dream?.name.includes(">");

    if (attributeMapRecord.attribute === EDA.problem && isBeingSolved) {
        const problemAttributeMapRecord = attributeMap.find(
            (elem) => elem.attribute === EDA.problem
        )!;

        return (
            <Glyphicon
                icon={problemAttributeMapRecord.icon}
                withClass={StyleClassAuto({ color: `#ffa839` })}
            />
        );
    }

    return (
        <Glyphicon
            icon={attributeMapRecord.icon}
            withClass={attributeMapRecord.iconClass}
        />
    );
};
